// The page a visitor sees in place of the music until they sign in with
// access (#410). The sign-in form is the drawer's own Account section, so a
// magic link or Google sign-in returns to this exact URL — a tune, recipe or
// playlist link opens once the gate lifts.

import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/session';
import { isPublicRoute, useMusicAccess } from '@/auth/musicAccess';
import { AccountSection } from './AccountSection';

export function SignInGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const access = useMusicAccess();
  const { status } = useAuth();
  if (access === 'open' || isPublicRoute(location.pathname)) return <>{children}</>;
  if (access === 'wait') return <div className="sign-in-gate" aria-busy="true" />;
  return (
    <div className="sign-in-gate" data-testid="sign-in-gate">
      <div className="sign-in-card">
        <h1>{status === 'needsCode' ? 'Enter your invite code' : 'Sign in'}</h1>
        {status === 'needsCode' && (
          <p className="muted">Your account needs an invite code to open the music.</p>
        )}
        <AccountSection />
      </div>
    </div>
  );
}
